import { render, staticRenderFns } from "./ReviewTransactionDetails.vue?vue&type=template&id=62cd4912&scoped=true"
import script from "./ReviewTransactionDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReviewTransactionDetails.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ReviewTransactionDetails.vue?vue&type=style&index=0&id=62cd4912&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cd4912",
  null
  
)

export default component.exports